/** SVG references
    Do not modify. This file is automatically generated and will be overwritten without warning.
    @readonly
    @enum {SVGElementModel[]}
*/
export const SVGS = {
    '_ICON_TEMPLATE': {
        element: 'svg',
        attributes: {
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'template'
                    },
                    data: {
                        children: [
                            {
                                element: 'rect',
                                attributes: {
                                    width: '512',
                                    height: '512'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    x: '64',
                                    y: '64',
                                    width: '384',
                                    height: '384',
                                    fill: '#3a3a3a'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    x: '128',
                                    y: '128',
                                    width: '256',
                                    height: '256',
                                    fill: '#8c8c8c'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'dots',
                        display: 'none'
                    },
                    data: {
                        children: [
                            {
                                element: 'circle',
                                attributes: {
                                    cx: '256',
                                    cy: '384',
                                    r: '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'circle',
                                attributes: {
                                    cx: '256',
                                    cy: '256',
                                    r: '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'circle',
                                attributes: {
                                    cx: '256',
                                    cy: '128',
                                    r: '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'lines',
                        display: 'none'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '96',
                                    y1: '384',
                                    x2: '416',
                                    y2: '384',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '96',
                                    y1: '256',
                                    x2: '416',
                                    y2: '256',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '96',
                                    y1: '128',
                                    x2: '416',
                                    y2: '128',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    '_SCRIPT_TEMPLATE': {
        element: 'svg',
        attributes: {
            id: 'icon',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'cli'
                    },
                    data: {
                        children: [
                            {
                                element: 'g',
                                attributes: {
                                    id: 'window'
                                },
                                data: {
                                    children: [
                                        {
                                            element: 'rect',
                                            attributes: {
                                                id: 'window1',
                                                'data-name': 'window',
                                                x: '81.3',
                                                y: '112.3',
                                                width: '349.8',
                                                height: '288.8',
                                                rx: '26.9',
                                                ry: '26.9',
                                                fill: 'none',
                                                stroke: '#000',
                                                'stroke-linecap': 'round',
                                                'stroke-linejoin': 'round',
                                                'stroke-width': '32'
                                            },
                                            data: {
                                                children: []
                                            },
                                            meta: {}
                                        },
                                        {
                                            element: 'path',
                                            attributes: {
                                                id: 'nav',
                                                d: 'M81.3,122.3v71h349.8v-71H81.3ZM111.6,180.3c-7.2,0-13-5.8-13-13s5.8-13,13-13,13,5.8,13,13-5.8,13-13,13ZM143.3,180.3c-7.2,0-13-5.8-13-13s5.8-13,13-13,13,5.8,13,13c0,7.2-5.8,13-13,13ZM175,180.3c-7.2,0-13-5.8-13-13s5.8-13,13-13,13,5.8,13,13-5.8,13-13,13Z'
                                            },
                                            data: {
                                                children: []
                                            },
                                            meta: {}
                                        }
                                    ]
                                },
                                meta: {}
                            },
                            {
                                element: 'g',
                                attributes: {
                                    id: 'symbols'
                                },
                                data: {
                                    children: [
                                        {
                                            element: 'g',
                                            attributes: {
                                                id: 'prompt',
                                                display: 'none'
                                            },
                                            data: {
                                                children: [
                                                    {
                                                        element: 'line',
                                                        attributes: {
                                                            x1: '193',
                                                            y1: '336.4',
                                                            x2: '256',
                                                            y2: '286',
                                                            fill: 'none',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-miterlimit': '10',
                                                            'stroke-width': '16'
                                                        },
                                                        data: {
                                                            children: []
                                                        },
                                                        meta: {}
                                                    },
                                                    {
                                                        element: 'line',
                                                        attributes: {
                                                            x1: '256',
                                                            y1: '336.4',
                                                            x2: '319',
                                                            y2: '336.4',
                                                            fill: 'none',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-miterlimit': '10',
                                                            'stroke-width': '16'
                                                        },
                                                        data: {
                                                            children: []
                                                        },
                                                        meta: {}
                                                    },
                                                    {
                                                        element: 'line',
                                                        attributes: {
                                                            x1: '193',
                                                            y1: '235.6',
                                                            x2: '256',
                                                            y2: '286',
                                                            fill: 'none',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-miterlimit': '10',
                                                            'stroke-width': '16'
                                                        },
                                                        data: {
                                                            children: []
                                                        },
                                                        meta: {}
                                                    }
                                                ]
                                            },
                                            meta: {}
                                        },
                                        {
                                            element: 'g',
                                            attributes: {
                                                id: 'brackets',
                                                display: 'none'
                                            },
                                            data: {
                                                children: [
                                                    {
                                                        element: 'path',
                                                        attributes: {
                                                            id: 'bracket-right',
                                                            d: 'M289.9,234.9h2.8c9.8,0,13.7,4.5,13.7,15.6v18.2c0,10,5,15.2,15.2,16.2v1.7c-10.2,1-15.2,6.2-15.2,16.2v18.2c0,11.1-4,15.6-13.7,15.6h-2.8',
                                                            fill: 'none',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-miterlimit': '10',
                                                            'stroke-width': '16'
                                                        },
                                                        data: {
                                                            children: []
                                                        },
                                                        meta: {}
                                                    },
                                                    {
                                                        element: 'path',
                                                        attributes: {
                                                            id: 'bracket-left',
                                                            d: 'M219.6,336.7h-2.8c-9.8,0-13.7-4.5-13.7-15.6v-18.2c0-10-5-15.2-15.2-16.2v-1.7c10.2-1,15.2-6.2,15.2-16.2v-18.2c0-11.1,4-15.6,13.7-15.6h2.8',
                                                            fill: 'none',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-miterlimit': '10',
                                                            'stroke-width': '16'
                                                        },
                                                        data: {
                                                            children: []
                                                        },
                                                        meta: {}
                                                    }
                                                ]
                                            },
                                            meta: {}
                                        },
                                        {
                                            element: 'g',
                                            attributes: {
                                                id: 'asterisk',
                                                display: 'none'
                                            },
                                            data: {
                                                children: [
                                                    {
                                                        element: 'text',
                                                        attributes: {
                                                            transform: 'translate(229.8 332.1)',
                                                            'font-family': 'Consolas, Consolas',
                                                            'font-size': '96',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-linejoin': 'round',
                                                            'stroke-width': '6'
                                                        },
                                                        data: {
                                                            children: [
                                                                {
                                                                    element: 'tspan',
                                                                    attributes: {
                                                                        x: '0',
                                                                        y: '0'
                                                                    },
                                                                    data: {
                                                                        children: [],
                                                                        text: '*'
                                                                    },
                                                                    meta: {}
                                                                }
                                                            ]
                                                        },
                                                        meta: {}
                                                    }
                                                ]
                                            },
                                            meta: {}
                                        },
                                        {
                                            element: 'g',
                                            attributes: {
                                                id: 'text'
                                            },
                                            data: {
                                                children: [
                                                    {
                                                        element: 'text',
                                                        attributes: {
                                                            transform: 'translate(144.9 313.1)',
                                                            display: 'none',
                                                            'font-family': 'Consolas, Consolas',
                                                            'font-size': '96',
                                                            'letter-spacing': '0em',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-linejoin': 'round',
                                                            'stroke-width': '6'
                                                        },
                                                        data: {
                                                            children: [
                                                                {
                                                                    element: 'tspan',
                                                                    attributes: {
                                                                        x: '0',
                                                                        y: '0'
                                                                    },
                                                                    data: {
                                                                        children: [],
                                                                        text: 'text'
                                                                    },
                                                                    meta: {}
                                                                }
                                                            ]
                                                        },
                                                        meta: {}
                                                    },
                                                    {
                                                        element: 'text',
                                                        attributes: {
                                                            transform: 'translate(201.5 313.1)',
                                                            display: 'none',
                                                            'font-family': 'Consolas, Consolas',
                                                            'font-size': '96',
                                                            'letter-spacing': '0em',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-linejoin': 'round',
                                                            'stroke-width': '6'
                                                        },
                                                        data: {
                                                            children: [
                                                                {
                                                                    element: 'tspan',
                                                                    attributes: {
                                                                        x: '0',
                                                                        y: '0'
                                                                    },
                                                                    data: {
                                                                        children: [],
                                                                        text: '>_'
                                                                    },
                                                                    meta: {}
                                                                }
                                                            ]
                                                        },
                                                        meta: {}
                                                    },
                                                    {
                                                        element: 'text',
                                                        attributes: {
                                                            transform: 'translate(201.5 313.1)',
                                                            display: 'none',
                                                            'font-family': 'Consolas, Consolas',
                                                            'font-size': '96',
                                                            'letter-spacing': '0em',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-linejoin': 'round',
                                                            'stroke-width': '6'
                                                        },
                                                        data: {
                                                            children: [
                                                                {
                                                                    element: 'tspan',
                                                                    attributes: {
                                                                        x: '0',
                                                                        y: '0'
                                                                    },
                                                                    data: {
                                                                        children: [],
                                                                        text: '$_'
                                                                    },
                                                                    meta: {}
                                                                }
                                                            ]
                                                        },
                                                        meta: {}
                                                    },
                                                    {
                                                        element: 'text',
                                                        attributes: {
                                                            transform: 'translate(229.8 313.1)',
                                                            display: 'none',
                                                            'font-family': 'Consolas, Consolas',
                                                            'font-size': '96',
                                                            'letter-spacing': '0em',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-linejoin': 'round',
                                                            'stroke-width': '6'
                                                        },
                                                        data: {
                                                            children: [
                                                                {
                                                                    element: 'tspan',
                                                                    attributes: {
                                                                        x: '0',
                                                                        y: '0'
                                                                    },
                                                                    data: {
                                                                        children: [],
                                                                        text: '>'
                                                                    },
                                                                    meta: {}
                                                                }
                                                            ]
                                                        },
                                                        meta: {}
                                                    },
                                                    {
                                                        element: 'text',
                                                        attributes: {
                                                            transform: 'translate(173.2 313.1)',
                                                            display: 'none',
                                                            'font-family': 'Consolas, Consolas',
                                                            'font-size': '96',
                                                            'letter-spacing': '0em',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-linejoin': 'round',
                                                            'stroke-width': '6'
                                                        },
                                                        data: {
                                                            children: [
                                                                {
                                                                    element: 'tspan',
                                                                    attributes: {
                                                                        x: '0',
                                                                        y: '0'
                                                                    },
                                                                    data: {
                                                                        children: [],
                                                                        text: '>>>'
                                                                    },
                                                                    meta: {}
                                                                }
                                                            ]
                                                        },
                                                        meta: {}
                                                    },
                                                    {
                                                        element: 'text',
                                                        attributes: {
                                                            transform: 'translate(104 313.1)',
                                                            'font-family': 'Consolas, Consolas',
                                                            'font-size': '87',
                                                            'letter-spacing': '0em',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-linejoin': 'round',
                                                            'stroke-width': '.8'
                                                        },
                                                        data: {
                                                            children: [
                                                                {
                                                                    element: 'tspan',
                                                                    attributes: {
                                                                        x: '0',
                                                                        y: '0'
                                                                    },
                                                                    data: {
                                                                        children: [],
                                                                        text: 'ai2svg'
                                                                    },
                                                                    meta: {}
                                                                }
                                                            ]
                                                        },
                                                        meta: {}
                                                    }
                                                ]
                                            },
                                            meta: {}
                                        }
                                    ]
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'text',
                    attributes: {
                        transform: 'translate(357.2 156.8)',
                        fill: '#fff',
                        'font-family': 'Consolas, Consolas',
                        'font-size': '53',
                        'letter-spacing': '0em'
                    },
                    data: {
                        children: [
                            {
                                element: 'tspan',
                                attributes: {
                                    x: '0',
                                    y: '0'
                                },
                                data: {
                                    children: [],
                                    text: 'js'
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'ARCHIVE': {
        element: 'svg',
        attributes: {
            id: 'archive',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'rect',
                    attributes: {
                        id: 'box',
                        x: '81.3',
                        y: '112.3',
                        width: '349.8',
                        height: '288.8',
                        rx: '26.9',
                        ry: '26.9',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-linejoin': 'round',
                        'stroke-width': '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        id: 'handle',
                        x1: '170.8',
                        y1: '245.3',
                        x2: '341.6',
                        y2: '245.3',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '24'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        id: 'lid',
                        d: 'M81.3,122.3v71h349.8v-71H81.3Z'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'ARROW_DOWN_FILL': {
        element: 'svg',
        attributes: {
            id: 'arrow',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'polyline',
                    attributes: {
                        points: '256 336.1 128 175.9 384 175.9 256 336.1 384 175.9',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-linejoin': 'round',
                        'stroke-width': '64'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'ARROW_DOWN': {
        element: 'svg',
        attributes: {
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'template',
                        display: 'none'
                    },
                    data: {
                        children: [
                            {
                                element: 'rect',
                                attributes: {
                                    width: '512',
                                    height: '512'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    x: '64',
                                    y: '64',
                                    width: '384',
                                    height: '384',
                                    fill: '#3a3a3a'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    x: '128',
                                    y: '128',
                                    width: '256',
                                    height: '256',
                                    fill: '#8c8c8c'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'dots',
                        display: 'none'
                    },
                    data: {
                        children: [
                            {
                                element: 'circle',
                                attributes: {
                                    cx: '256',
                                    cy: '384',
                                    r: '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'circle',
                                attributes: {
                                    cx: '256',
                                    cy: '256',
                                    r: '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'circle',
                                attributes: {
                                    cx: '256',
                                    cy: '128',
                                    r: '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'lines',
                        display: 'none'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '96',
                                    y1: '384',
                                    x2: '416',
                                    y2: '384',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '96',
                                    y1: '256',
                                    x2: '416',
                                    y2: '256',
                                    display: 'none',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '96',
                                    y1: '128',
                                    x2: '416',
                                    y2: '128',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'lines_copy'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '128',
                                    y1: '175.9',
                                    x2: '256',
                                    y2: '336.1',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '384',
                                    y1: '175.9',
                                    x2: '256',
                                    y2: '336.1',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'ARROW_DOWN_48PX': {
        element: 'svg',
        attributes: {
            id: 'Icon',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 48 48'
        },
        data: {
            children: [
                {
                    element: 'line',
                    attributes: {
                        x1: '5',
                        y1: '15',
                        x2: '24',
                        y2: '33',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        x1: '43',
                        y1: '15',
                        x2: '24',
                        y2: '33',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'ARROW_LEFT_FILL': {
        element: 'svg',
        attributes: {
            id: 'arrow',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'polyline',
                    attributes: {
                        points: '175.9 256 336.1 128 336.1 384 175.9 256 336.1 384',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-linejoin': 'round',
                        'stroke-width': '64'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'ARROW_LEFT': {
        element: 'svg',
        attributes: {
            id: 'arrow',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'line',
                    attributes: {
                        x1: '336.1',
                        y1: '128',
                        x2: '175.9',
                        y2: '256',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        x1: '336.1',
                        y1: '384',
                        x2: '175.9',
                        y2: '256',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'ARROW_RIGHT_FILL': {
        element: 'svg',
        attributes: {
            id: 'arrow',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'polyline',
                    attributes: {
                        points: '336.1 256 175.9 384 175.9 128 336.1 256 175.9 128',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-linejoin': 'round',
                        'stroke-width': '64'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'ARROW_RIGHT': {
        element: 'svg',
        attributes: {
            id: 'arrow',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'line',
                    attributes: {
                        x1: '175.9',
                        y1: '384',
                        x2: '336.1',
                        y2: '256',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        x1: '175.9',
                        y1: '128',
                        x2: '336.1',
                        y2: '256',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'ARROW_UP': {
        element: 'svg',
        attributes: {
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'template',
                        display: 'none'
                    },
                    data: {
                        children: [
                            {
                                element: 'rect',
                                attributes: {
                                    width: '512',
                                    height: '512'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    x: '64',
                                    y: '64',
                                    width: '384',
                                    height: '384',
                                    fill: '#3a3a3a'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    x: '128',
                                    y: '128',
                                    width: '256',
                                    height: '256',
                                    fill: '#8c8c8c'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'dots',
                        display: 'none'
                    },
                    data: {
                        children: [
                            {
                                element: 'circle',
                                attributes: {
                                    cx: '256',
                                    cy: '384',
                                    r: '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'circle',
                                attributes: {
                                    cx: '256',
                                    cy: '256',
                                    r: '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'circle',
                                attributes: {
                                    cx: '256',
                                    cy: '128',
                                    r: '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'lines',
                        display: 'none'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '96',
                                    y1: '384',
                                    x2: '416',
                                    y2: '384',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '96',
                                    y1: '256',
                                    x2: '416',
                                    y2: '256',
                                    display: 'none',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '96',
                                    y1: '128',
                                    x2: '416',
                                    y2: '128',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'lines_copy'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '384',
                                    y1: '336.1',
                                    x2: '256',
                                    y2: '175.9',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '128',
                                    y1: '336.1',
                                    x2: '256',
                                    y2: '175.9',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'ARROW_UP_48PX': {
        element: 'svg',
        attributes: {
            id: 'Icon',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 48 48'
        },
        data: {
            children: [
                {
                    element: 'line',
                    attributes: {
                        x1: '43',
                        y1: '33',
                        x2: '24',
                        y2: '15',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        x1: '5',
                        y1: '33',
                        x2: '24',
                        y2: '15',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'BACKSLASH': {
        element: 'svg',
        attributes: {
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'template',
                        display: 'none'
                    },
                    data: {
                        children: [
                            {
                                element: 'rect',
                                attributes: {
                                    width: '512',
                                    height: '512'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    x: '64',
                                    y: '64',
                                    width: '384',
                                    height: '384',
                                    fill: '#3a3a3a'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    x: '128',
                                    y: '128',
                                    width: '256',
                                    height: '256',
                                    fill: '#8c8c8c'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'dots',
                        display: 'none'
                    },
                    data: {
                        children: [
                            {
                                element: 'circle',
                                attributes: {
                                    cx: '256',
                                    cy: '352',
                                    r: '40'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'circle',
                                attributes: {
                                    cx: '256',
                                    cy: '256',
                                    r: '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'circle',
                                attributes: {
                                    cx: '256',
                                    cy: '160',
                                    r: '40'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'lines',
                        display: 'none'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '96',
                                    y1: '384',
                                    x2: '416',
                                    y2: '384',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '96',
                                    y1: '256',
                                    x2: '416',
                                    y2: '256',
                                    display: 'none',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '96',
                                    y1: '128',
                                    x2: '416',
                                    y2: '128',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'symbol'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '142.9',
                                    y1: '369.1',
                                    x2: '369.1',
                                    y2: '142.9',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '256',
                                    y1: '416',
                                    x2: '256',
                                    y2: '96',
                                    display: 'none',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'BLANK': {
        element: 'svg',
        attributes: {
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: []
        },
        meta: {}
    },
    'CHECKMARK': {
        element: 'svg',
        attributes: {
            id: 'symbol',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'line',
                    attributes: {
                        x1: '132',
                        y1: '256',
                        x2: '257.1',
                        y2: '416',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        x1: '258',
                        y1: '416',
                        x2: '418',
                        y2: '96',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'CIRCLE_ENGLISH_48PX': {
        element: 'svg',
        attributes: {
            id: 'Icon',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 48 48'
        },
        data: {
            children: [
                {
                    element: 'circle',
                    attributes: {
                        cx: '24',
                        cy: '24',
                        r: '20'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'text',
                    attributes: {
                        transform: 'translate(10.4 31)',
                        fill: '#fff',
                        'font-family': 'SourceSansPro-Regular, \'Source Sans Pro\'',
                        'font-size': '26'
                    },
                    data: {
                        children: [
                            {
                                element: 'tspan',
                                attributes: {
                                    x: '0',
                                    y: '0'
                                },
                                data: {
                                    children: [],
                                    text: 'en'
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'CIRCLE_EXCLAMATIONMARK_48PX': {
        element: 'svg',
        attributes: {
            id: 'Shape',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 48 48'
        },
        data: {
            children: [
                {
                    element: 'circle',
                    attributes: {
                        cx: '24',
                        cy: '24',
                        r: '20'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'text',
                    attributes: {
                        transform: 'translate(19.6 34)',
                        fill: '#fff',
                        'font-family': 'SourceSansPro-Regular, \'Source Sans Pro\'',
                        'font-size': '30'
                    },
                    data: {
                        children: [
                            {
                                element: 'tspan',
                                attributes: {
                                    x: '0',
                                    y: '0'
                                },
                                data: {
                                    children: [],
                                    text: '!'
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'CIRCLE_FILL_2CHARS': {
        element: 'svg',
        attributes: {
            id: 'symbol',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'circle',
                    attributes: {
                        id: 'circle',
                        cx: '256',
                        cy: '256',
                        r: '192',
                        fill: '#231f20'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'text',
                    attributes: {
                        id: 'text',
                        transform: 'translate(128 341.4)',
                        fill: '#fff',
                        'font-family': 'ArialMT, Arial',
                        'font-size': '230.2'
                    },
                    data: {
                        children: [
                            {
                                element: 'tspan',
                                attributes: {
                                    x: '0',
                                    y: '0'
                                },
                                data: {
                                    children: [],
                                    text: '00'
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'CIRCLE_FRENCH_48PX': {
        element: 'svg',
        attributes: {
            id: 'Icon',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 48 48'
        },
        data: {
            children: [
                {
                    element: 'circle',
                    attributes: {
                        cx: '24',
                        cy: '24',
                        r: '20'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'text',
                    attributes: {
                        transform: 'translate(14.7 33)',
                        fill: '#fff',
                        'font-family': 'SourceSansPro-Regular, \'Source Sans Pro\'',
                        'font-size': '26'
                    },
                    data: {
                        children: [
                            {
                                element: 'tspan',
                                attributes: {
                                    x: '0',
                                    y: '0'
                                },
                                data: {
                                    children: [],
                                    text: 'fr'
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'CIRCLE_QUESTIONMARK_48PX': {
        element: 'svg',
        attributes: {
            id: 'Layer_1',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 48 48'
        },
        data: {
            children: [
                {
                    element: 'rect',
                    attributes: {
                        x: '11',
                        y: '10',
                        width: '26',
                        height: '26.3',
                        fill: 'none'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '24',
                        cy: '24',
                        r: '20'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'text',
                    attributes: {
                        transform: 'translate(17.6 34)',
                        fill: '#fff',
                        'font-family': 'SourceSansPro-Regular, \'Source Sans Pro\'',
                        'font-size': '30'
                    },
                    data: {
                        children: [
                            {
                                element: 'tspan',
                                attributes: {
                                    x: '0',
                                    y: '0'
                                },
                                data: {
                                    children: [],
                                    text: '?'
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'CIRCLE_STROKE_2CHARS': {
        element: 'svg',
        attributes: {
            id: 'symbol',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'circle',
                    attributes: {
                        cx: '256',
                        cy: '256',
                        r: '128',
                        fill: '#fff',
                        stroke: '#000',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'text',
                    attributes: {
                        transform: 'translate(183.2 297.7)',
                        'font-family': 'MyriadPro-Regular, \'Myriad Pro\'',
                        'font-size': '142'
                    },
                    data: {
                        children: [
                            {
                                element: 'tspan',
                                attributes: {
                                    x: '0',
                                    y: '0'
                                },
                                data: {
                                    children: [],
                                    text: '00'
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'CLI_BRACKETS': {
        element: 'svg',
        attributes: {
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'template',
                        display: 'none'
                    },
                    data: {
                        children: [
                            {
                                element: 'rect',
                                attributes: {
                                    width: '512',
                                    height: '512'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    x: '64',
                                    y: '64',
                                    width: '384',
                                    height: '384',
                                    fill: '#3a3a3a'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    x: '128',
                                    y: '128',
                                    width: '256',
                                    height: '256',
                                    fill: '#8c8c8c'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'tab'
                    },
                    data: {
                        children: [
                            {
                                element: 'rect',
                                attributes: {
                                    x: '81.3',
                                    y: '112.3',
                                    width: '349.8',
                                    height: '288.8',
                                    rx: '26.9',
                                    ry: '26.9',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-linejoin': 'round',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'path',
                                attributes: {
                                    id: 'nav',
                                    d: 'M81.3,122.3v71h349.8v-71H81.3ZM111.6,180.3c-7.2,0-13-5.8-13-13s5.8-13,13-13,13,5.8,13,13-5.8,13-13,13ZM143.3,180.3c-7.2,0-13-5.8-13-13s5.8-13,13-13,13,5.8,13,13c0,7.2-5.8,13-13,13ZM175,180.3c-7.2,0-13-5.8-13-13s5.8-13,13-13,13,5.8,13,13-5.8,13-13,13Z'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '193',
                                    y1: '336.4',
                                    x2: '256',
                                    y2: '286',
                                    display: 'none',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '256',
                                    y1: '336.4',
                                    x2: '319',
                                    y2: '336.4',
                                    display: 'none',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '193',
                                    y1: '235.6',
                                    x2: '256',
                                    y2: '286',
                                    display: 'none',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'brackets'
                    },
                    data: {
                        children: [
                            {
                                element: 'path',
                                attributes: {
                                    id: 'bracket-right',
                                    d: 'M290.7,236h2.7c9.6,0,13.5,4.4,13.5,15.3v17.9c0,9.8,4.9,14.9,14.9,15.9v1.6c-10,1-14.9,6.1-14.9,15.9v17.9c0,10.9-3.9,15.3-13.5,15.3h-2.7',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '12'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'path',
                                attributes: {
                                    id: 'bracket-left',
                                    d: 'M221.8,335.9h-2.7c-9.6,0-13.5-4.4-13.5-15.3v-17.9c0-9.8-4.9-14.9-14.9-15.9v-1.6c10-1,14.9-6.1,14.9-15.9v-17.9c0-10.9,3.9-15.3,13.5-15.3h2.7',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '12'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'CLI_PROMPT': {
        element: 'svg',
        attributes: {
            id: 'lines_copy',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'line',
                    attributes: {
                        x1: '96',
                        y1: '384',
                        x2: '256.1',
                        y2: '256',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        x1: '256',
                        y1: '384',
                        x2: '416',
                        y2: '384',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        x1: '96',
                        y1: '128',
                        x2: '256.1',
                        y2: '256',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'CLOSE': {
        element: 'svg',
        attributes: {
            id: 'symbol',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'line',
                    attributes: {
                        id: 'line-2',
                        x1: '142.9',
                        y1: '369.1',
                        x2: '369.1',
                        y2: '142.9',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        id: 'line-1',
                        x1: '369.1',
                        y1: '369.1',
                        x2: '142.9',
                        y2: '142.9',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'CLOSE_48PX': {
        element: 'svg',
        attributes: {
            id: 'Icon',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 48 48'
        },
        data: {
            children: [
                {
                    element: 'line',
                    attributes: {
                        id: 'line-2',
                        x1: '10.6',
                        y1: '37.4',
                        x2: '37.4',
                        y2: '10.6',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        id: 'line-1',
                        x1: '37.4',
                        y1: '37.4',
                        x2: '10.6',
                        y2: '10.6',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'COMMAND_LINE': {
        element: 'svg',
        attributes: {
            id: 'icon',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'cli'
                    },
                    data: {
                        children: [
                            {
                                element: 'g',
                                attributes: {
                                    id: 'window'
                                },
                                data: {
                                    children: [
                                        {
                                            element: 'rect',
                                            attributes: {
                                                id: 'window1',
                                                'data-name': 'window',
                                                x: '81.3',
                                                y: '112.3',
                                                width: '349.8',
                                                height: '288.8',
                                                rx: '26.9',
                                                ry: '26.9',
                                                fill: 'none',
                                                stroke: '#000',
                                                'stroke-linecap': 'round',
                                                'stroke-linejoin': 'round',
                                                'stroke-width': '32'
                                            },
                                            data: {
                                                children: []
                                            },
                                            meta: {}
                                        },
                                        {
                                            element: 'path',
                                            attributes: {
                                                id: 'nav',
                                                d: 'M81.3,122.3v71h349.8v-71H81.3ZM111.6,180.3c-7.2,0-13-5.8-13-13s5.8-13,13-13,13,5.8,13,13-5.8,13-13,13ZM143.3,180.3c-7.2,0-13-5.8-13-13s5.8-13,13-13,13,5.8,13,13c0,7.2-5.8,13-13,13ZM175,180.3c-7.2,0-13-5.8-13-13s5.8-13,13-13,13,5.8,13,13-5.8,13-13,13Z'
                                            },
                                            data: {
                                                children: []
                                            },
                                            meta: {}
                                        }
                                    ]
                                },
                                meta: {}
                            },
                            {
                                element: 'g',
                                attributes: {
                                    id: 'symbols'
                                },
                                data: {
                                    children: [
                                        {
                                            element: 'g',
                                            attributes: {
                                                id: 'prompt',
                                                display: 'none'
                                            },
                                            data: {
                                                children: [
                                                    {
                                                        element: 'line',
                                                        attributes: {
                                                            x1: '193',
                                                            y1: '336.4',
                                                            x2: '256',
                                                            y2: '286',
                                                            fill: 'none',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-miterlimit': '10',
                                                            'stroke-width': '16'
                                                        },
                                                        data: {
                                                            children: []
                                                        },
                                                        meta: {}
                                                    },
                                                    {
                                                        element: 'line',
                                                        attributes: {
                                                            x1: '256',
                                                            y1: '336.4',
                                                            x2: '319',
                                                            y2: '336.4',
                                                            fill: 'none',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-miterlimit': '10',
                                                            'stroke-width': '16'
                                                        },
                                                        data: {
                                                            children: []
                                                        },
                                                        meta: {}
                                                    },
                                                    {
                                                        element: 'line',
                                                        attributes: {
                                                            x1: '193',
                                                            y1: '235.6',
                                                            x2: '256',
                                                            y2: '286',
                                                            fill: 'none',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-miterlimit': '10',
                                                            'stroke-width': '16'
                                                        },
                                                        data: {
                                                            children: []
                                                        },
                                                        meta: {}
                                                    }
                                                ]
                                            },
                                            meta: {}
                                        },
                                        {
                                            element: 'g',
                                            attributes: {
                                                id: 'brackets'
                                            },
                                            data: {
                                                children: [
                                                    {
                                                        element: 'path',
                                                        attributes: {
                                                            id: 'bracket-right',
                                                            d: 'M289.9,234.9h2.8c9.8,0,13.7,4.5,13.7,15.6v18.2c0,10,5,15.2,15.2,16.2v1.7c-10.2,1-15.2,6.2-15.2,16.2v18.2c0,11.1-4,15.6-13.7,15.6h-2.8',
                                                            fill: 'none',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-miterlimit': '10',
                                                            'stroke-width': '16'
                                                        },
                                                        data: {
                                                            children: []
                                                        },
                                                        meta: {}
                                                    },
                                                    {
                                                        element: 'path',
                                                        attributes: {
                                                            id: 'bracket-left',
                                                            d: 'M219.6,336.7h-2.8c-9.8,0-13.7-4.5-13.7-15.6v-18.2c0-10-5-15.2-15.2-16.2v-1.7c10.2-1,15.2-6.2,15.2-16.2v-18.2c0-11.1,4-15.6,13.7-15.6h2.8',
                                                            fill: 'none',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-miterlimit': '10',
                                                            'stroke-width': '16'
                                                        },
                                                        data: {
                                                            children: []
                                                        },
                                                        meta: {}
                                                    }
                                                ]
                                            },
                                            meta: {}
                                        },
                                        {
                                            element: 'g',
                                            attributes: {
                                                id: 'asterisk',
                                                display: 'none'
                                            },
                                            data: {
                                                children: [
                                                    {
                                                        element: 'text',
                                                        attributes: {
                                                            transform: 'translate(229.8 332.1)',
                                                            'font-family': 'Consolas, Consolas',
                                                            'font-size': '96',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-linejoin': 'round',
                                                            'stroke-width': '6'
                                                        },
                                                        data: {
                                                            children: [
                                                                {
                                                                    element: 'tspan',
                                                                    attributes: {
                                                                        x: '0',
                                                                        y: '0'
                                                                    },
                                                                    data: {
                                                                        children: [],
                                                                        text: '*'
                                                                    },
                                                                    meta: {}
                                                                }
                                                            ]
                                                        },
                                                        meta: {}
                                                    }
                                                ]
                                            },
                                            meta: {}
                                        },
                                        {
                                            element: 'g',
                                            attributes: {
                                                id: 'text',
                                                display: 'none'
                                            },
                                            data: {
                                                children: [
                                                    {
                                                        element: 'text',
                                                        attributes: {
                                                            transform: 'translate(144.9 313.1)',
                                                            display: 'none',
                                                            'font-family': 'Consolas, Consolas',
                                                            'font-size': '96',
                                                            'letter-spacing': '0em',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-linejoin': 'round',
                                                            'stroke-width': '6'
                                                        },
                                                        data: {
                                                            children: [
                                                                {
                                                                    element: 'tspan',
                                                                    attributes: {
                                                                        x: '0',
                                                                        y: '0'
                                                                    },
                                                                    data: {
                                                                        children: [],
                                                                        text: 'text'
                                                                    },
                                                                    meta: {}
                                                                }
                                                            ]
                                                        },
                                                        meta: {}
                                                    },
                                                    {
                                                        element: 'text',
                                                        attributes: {
                                                            transform: 'translate(201.5 313.1)',
                                                            display: 'none',
                                                            'font-family': 'Consolas, Consolas',
                                                            'font-size': '96',
                                                            'letter-spacing': '0em',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-linejoin': 'round',
                                                            'stroke-width': '6'
                                                        },
                                                        data: {
                                                            children: [
                                                                {
                                                                    element: 'tspan',
                                                                    attributes: {
                                                                        x: '0',
                                                                        y: '0'
                                                                    },
                                                                    data: {
                                                                        children: [],
                                                                        text: '>_'
                                                                    },
                                                                    meta: {}
                                                                }
                                                            ]
                                                        },
                                                        meta: {}
                                                    },
                                                    {
                                                        element: 'text',
                                                        attributes: {
                                                            transform: 'translate(201.5 313.1)',
                                                            display: 'none',
                                                            'font-family': 'Consolas, Consolas',
                                                            'font-size': '96',
                                                            'letter-spacing': '0em',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-linejoin': 'round',
                                                            'stroke-width': '6'
                                                        },
                                                        data: {
                                                            children: [
                                                                {
                                                                    element: 'tspan',
                                                                    attributes: {
                                                                        x: '0',
                                                                        y: '0'
                                                                    },
                                                                    data: {
                                                                        children: [],
                                                                        text: '$_'
                                                                    },
                                                                    meta: {}
                                                                }
                                                            ]
                                                        },
                                                        meta: {}
                                                    },
                                                    {
                                                        element: 'text',
                                                        attributes: {
                                                            transform: 'translate(229.8 313.1)',
                                                            display: 'none',
                                                            'font-family': 'Consolas, Consolas',
                                                            'font-size': '96',
                                                            'letter-spacing': '0em',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-linejoin': 'round',
                                                            'stroke-width': '6'
                                                        },
                                                        data: {
                                                            children: [
                                                                {
                                                                    element: 'tspan',
                                                                    attributes: {
                                                                        x: '0',
                                                                        y: '0'
                                                                    },
                                                                    data: {
                                                                        children: [],
                                                                        text: '>'
                                                                    },
                                                                    meta: {}
                                                                }
                                                            ]
                                                        },
                                                        meta: {}
                                                    },
                                                    {
                                                        element: 'text',
                                                        attributes: {
                                                            transform: 'translate(173.2 313.1)',
                                                            display: 'none',
                                                            'font-family': 'Consolas, Consolas',
                                                            'font-size': '96',
                                                            'letter-spacing': '0em',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-linejoin': 'round',
                                                            'stroke-width': '6'
                                                        },
                                                        data: {
                                                            children: [
                                                                {
                                                                    element: 'tspan',
                                                                    attributes: {
                                                                        x: '0',
                                                                        y: '0'
                                                                    },
                                                                    data: {
                                                                        children: [],
                                                                        text: '>>>'
                                                                    },
                                                                    meta: {}
                                                                }
                                                            ]
                                                        },
                                                        meta: {}
                                                    },
                                                    {
                                                        element: 'text',
                                                        attributes: {
                                                            transform: 'translate(201.5 313.1)',
                                                            'font-family': 'Consolas, Consolas',
                                                            'font-size': '96',
                                                            'letter-spacing': '0em',
                                                            stroke: '#000',
                                                            'stroke-linecap': 'round',
                                                            'stroke-linejoin': 'round',
                                                            'stroke-width': '6'
                                                        },
                                                        data: {
                                                            children: [
                                                                {
                                                                    element: 'tspan',
                                                                    attributes: {
                                                                        x: '0',
                                                                        y: '0'
                                                                    },
                                                                    data: {
                                                                        children: [],
                                                                        text: ';)'
                                                                    },
                                                                    meta: {}
                                                                }
                                                            ]
                                                        },
                                                        meta: {}
                                                    }
                                                ]
                                            },
                                            meta: {}
                                        }
                                    ]
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'DATABASE_FILL': {
        element: 'svg',
        attributes: {
            id: 'database',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'path',
                    attributes: {
                        d: 'M233.2,447.6c-35.9-2.6-71.4-11.6-93.2-23.7-12.4-6.9-21.9-15.4-25.6-22.9l-2.2-4.5V114.6l1.7-3.5c7.8-15.8,32.7-30.1,67.5-38.7,11.8-2.9,28.8-5.8,42.7-7.3,14.2-1.5,51.8-1.3,66,.4,37.6,4.4,69.6,14.3,89.4,27.6,7.6,5.1,15.4,13.3,18.1,19l2.3,4.8-.2,140.5-.2,140.5-1.8,3.7c-1,2-4,6-6.7,8.9-16.4,17.4-51.6,30.3-97.7,35.7-9.4,1.1-50.3,2-59.9,1.3h0ZM275.4,146.6c23.2-1.6,40.6-4.7,55.9-9.8,15.3-5.1,24.3-11.3,26.3-18,.8-2.6.7-3.6-.4-6.4-4.9-12.7-32.1-22.5-73.6-26.5-17.8-1.7-50.1-1.1-67,1.1-25.9,3.5-46.8,10-56.2,17.4-18.9,14.9,1.1,31.4,47.5,39.1,20.1,3.4,46.2,4.5,67.5,3.1h0Z'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'DATABASE': {
        element: 'svg',
        attributes: {
            id: 'database',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'path',
                    attributes: {
                        d: 'M253.3,64.1c14.2,0,29,.5,36.8,1.4,37.6,4.4,69.6,14.3,89.4,27.6,7.6,5.1,15.4,13.3,18.1,19l2.3,4.8-.2,140.5-.2,140.5-1.8,3.7c-1,2-4,6-6.7,8.9-16.4,17.4-51.6,30.3-97.7,35.7-7.1.8-32.3,1.6-48.2,1.6s-9.3,0-11.7-.2h0c-35.9-2.6-71.4-11.6-93.2-23.7-12.4-6.9-21.9-15.4-25.6-22.9l-2.2-4.5V114.6l1.7-3.5c7.8-15.8,32.7-30.1,67.5-38.7,11.8-2.9,28.8-5.8,42.7-7.3,6.4-.7,17.5-1,29.2-1M253.3,40.1c-7.8,0-22.3.1-31.7,1.1-15,1.6-33.1,4.7-46,7.8-24.6,6.1-68.2,20.8-83.2,51.4l-1.7,3.5-2.5,5v293.1l2.5,5,2.2,4.5c8,16.3,25.6,27.9,35.4,33.3,19.4,10.8,47,19.2,77,23.8l-.2,1,26.3,1.9c2.9.2,7.2.3,13.4.3,15.2,0,42-.7,51.1-1.7,24.8-2.9,46.8-7.9,65.4-14.7,20.4-7.5,36.2-17,46.9-28.4,3.4-3.6,8.3-9.6,10.8-14.8l1.8-3.7,2.5-5v-5.6s.2-140.5.2-140.5l.2-140.5v-5.4s-2.3-4.9-2.3-4.9l-2.3-4.8c-5.5-11.8-17.7-22.8-26.4-28.7-22.9-15.5-58.4-26.7-100-31.6-12.3-1.4-33.4-1.6-39.6-1.6h0Z'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        d: 'M257.6,84.9c9.7,0,19,.3,26.1,1,41.5,4,68.7,13.8,73.6,26.5,1.1,2.8,1.1,3.8.4,6.4-2,6.7-11,12.9-26.3,18-15.3,5.1-32.7,8.2-55.9,9.8h0c-6.1.4-12.5.6-19.1.6-16.5,0-34-1.3-48.4-3.7-46.4-7.7-66.4-24.2-47.5-39.1,9.3-7.4,30.3-13.9,56.2-17.4,10.2-1.4,26.1-2.1,41-2.1M257.6,68.9c-16.5,0-32.6.9-43.1,2.3-17,2.3-48,8.1-64,20.7-15.1,12-13.6,25.3-12.3,30.5,4.6,17.9,27.2,30.3,67.1,37,15.1,2.5,33.2,3.9,51,3.9s13.8-.2,20.2-.7c24.7-1.7,43.2-5,59.9-10.6,20.9-7,32.9-16.3,36.5-28.6,1.8-6,1.6-10.6-.7-16.7-7.5-19.6-36.8-31.9-87-36.7-9.2-.9-20.1-1.1-27.6-1.1h0Z'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'DISK_48PX': {
        element: 'svg',
        attributes: {
            id: 'Icon',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 48 48'
        },
        data: {
            children: [
                {
                    element: 'rect',
                    attributes: {
                        id: 'outer',
                        x: '5',
                        y: '5',
                        width: '38',
                        height: '38',
                        rx: '2',
                        ry: '2',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-miterlimit': '10',
                        'stroke-width': '2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        id: 'top',
                        d: 'M13,5h21v10c0,1.1-.9,2-2,2H15c-1.1,0-2-.9-2-2V5h0Z',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-miterlimit': '10',
                        'stroke-width': '2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'polygon',
                    attributes: {
                        id: 'corner',
                        points: '42 11.7 36 6 42 6 42 11.7'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        x1: '30',
                        y1: '9',
                        x2: '30',
                        y2: '13',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        id: 'top1',
                        'data-name': 'top',
                        d: 'M9,23h30v18c0,1.1-.9,2-2,2H11c-1.1,0-2-.9-2-2v-18h0Z',
                        transform: 'translate(48 66) rotate(180)',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-miterlimit': '10',
                        'stroke-width': '2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'DIVIDE': {
        element: 'svg',
        attributes: {
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'template',
                        display: 'none'
                    },
                    data: {
                        children: [
                            {
                                element: 'rect',
                                attributes: {
                                    width: '512',
                                    height: '512'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    x: '64',
                                    y: '64',
                                    width: '384',
                                    height: '384',
                                    fill: '#3a3a3a'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    x: '128',
                                    y: '128',
                                    width: '256',
                                    height: '256',
                                    fill: '#8c8c8c'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'dots'
                    },
                    data: {
                        children: [
                            {
                                element: 'circle',
                                attributes: {
                                    cx: '256',
                                    cy: '352',
                                    r: '40'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'circle',
                                attributes: {
                                    cx: '256',
                                    cy: '256',
                                    r: '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'circle',
                                attributes: {
                                    cx: '256',
                                    cy: '160',
                                    r: '40'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'lines',
                        display: 'none'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '96',
                                    y1: '384',
                                    x2: '416',
                                    y2: '384',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '96',
                                    y1: '256',
                                    x2: '416',
                                    y2: '256',
                                    display: 'none',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '96',
                                    y1: '128',
                                    x2: '416',
                                    y2: '128',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'symbol'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '96',
                                    y1: '256',
                                    x2: '416',
                                    y2: '256',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '256',
                                    y1: '416',
                                    x2: '256',
                                    y2: '96',
                                    display: 'none',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'DOC': {
        element: 'svg',
        attributes: {
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'page'
                    },
                    data: {
                        children: [
                            {
                                element: 'g',
                                attributes: {
                                    id: 'page1',
                                    'data-name': 'page',
                                    display: 'none'
                                },
                                data: {
                                    children: [
                                        {
                                            element: 'path',
                                            attributes: {
                                                d: 'M365.3,91.2c9.9,0,18,8.1,18,18v295c0,9.9-8.1,18-18,18h-218.7c-9.9,0-18-8.1-18-18V109.2c0-9.9,8.1-18,18-18h218.7M365.3,75.2h-218.7c-18.7,0-34,15.3-34,34v295c0,18.7,15.3,34,34,34h218.7c18.7,0,34-15.3,34-34V109.2c0-18.7-15.3-34-34-34h0Z'
                                            },
                                            data: {
                                                children: []
                                            },
                                            meta: {}
                                        }
                                    ]
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    id: 'page2',
                                    'data-name': 'page',
                                    x: '120.3',
                                    y: '83.1',
                                    width: '272',
                                    height: '347.6',
                                    rx: '4',
                                    ry: '4',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'polygon',
                                attributes: {
                                    id: 'corner',
                                    points: '388.2 143.3 331.3 86.4 388.2 86.4 388.2 143.3'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'lines'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '192.4',
                                    y1: '297.8',
                                    x2: '320',
                                    y2: '297.8',
                                    display: 'none',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '192.4',
                                    y1: '345.3',
                                    x2: '279.1',
                                    y2: '345.3',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '192.4',
                                    y1: '155.3',
                                    x2: '320',
                                    y2: '155.3',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '192.4',
                                    y1: '202.8',
                                    x2: '320',
                                    y2: '202.8',
                                    display: 'none',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '192.4',
                                    y1: '250.3',
                                    x2: '320',
                                    y2: '250.3',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'DOUBLE_ARROW_DOWN': {
        element: 'svg',
        attributes: {
            id: 'double-arrow',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'arrow-2'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '128.3',
                                    y1: '96.4',
                                    x2: '256.3',
                                    y2: '256.6',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '384.3',
                                    y1: '96.4',
                                    x2: '256.3',
                                    y2: '256.6',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'arrow-1'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '128.3',
                                    y1: '255.4',
                                    x2: '256.3',
                                    y2: '415.6',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '384.3',
                                    y1: '255.4',
                                    x2: '256.3',
                                    y2: '415.6',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'DOUBLE_ARROW_LEFT': {
        element: 'svg',
        attributes: {
            id: 'double-arrow',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'arrow-2'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '415.9',
                                    y1: '128',
                                    x2: '255.8',
                                    y2: '256',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '415.9',
                                    y1: '384',
                                    x2: '255.8',
                                    y2: '256',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'arrow-1'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '256.9',
                                    y1: '128',
                                    x2: '96.8',
                                    y2: '256',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '256.9',
                                    y1: '384',
                                    x2: '96.8',
                                    y2: '256',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'DOUBLE_ARROW_LEFT_48PX': {
        element: 'svg',
        attributes: {
            id: 'Icon',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 48 48'
        },
        data: {
            children: [
                {
                    element: 'line',
                    attributes: {
                        x1: '41',
                        y1: '5',
                        x2: '22',
                        y2: '24',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        x1: '41',
                        y1: '43',
                        x2: '22',
                        y2: '24',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        x1: '26',
                        y1: '5',
                        x2: '7',
                        y2: '24',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        x1: '26',
                        y1: '43',
                        x2: '7',
                        y2: '24',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'DOUBLE_ARROW_RIGHT': {
        element: 'svg',
        attributes: {
            id: 'double-arrow',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'arrow-2'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '96.8',
                                    y1: '384',
                                    x2: '256.9',
                                    y2: '256',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '96.8',
                                    y1: '128',
                                    x2: '256.9',
                                    y2: '256',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'arrow-1'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '255.8',
                                    y1: '384',
                                    x2: '415.9',
                                    y2: '256',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '255.8',
                                    y1: '128',
                                    x2: '415.9',
                                    y2: '256',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'DOUBLE_ARROW_UP': {
        element: 'svg',
        attributes: {
            id: 'double-arrow',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'arrow-2'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '384.3',
                                    y1: '415.6',
                                    x2: '256.3',
                                    y2: '255.4',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '128.3',
                                    y1: '415.6',
                                    x2: '256.3',
                                    y2: '255.4',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'arrow-1'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '384.3',
                                    y1: '256.6',
                                    x2: '256.3',
                                    y2: '96.4',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '128.3',
                                    y1: '256.6',
                                    x2: '256.3',
                                    y2: '96.4',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '64'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'ENVELOPE': {
        element: 'svg',
        attributes: {
            id: 'envelope',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'rect',
                    attributes: {
                        id: 'outer',
                        x: '110.6',
                        y: '155.1',
                        width: '291.3',
                        height: '194.2',
                        rx: '4',
                        ry: '4',
                        fill: '#fff',
                        stroke: '#000',
                        'stroke-width': '8'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'polyline',
                    attributes: {
                        id: 'inner',
                        points: '112.6 157.1 256.2 276.5 399.8 157.1',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-width': '8'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'ETHICS_48PX': {
        element: 'svg',
        attributes: {
            id: 'Icon',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 48 48'
        },
        data: {
            children: [
                {
                    element: 'path',
                    attributes: {
                        id: 'stand',
                        d: 'M28.9,39.9c-.3-1.4-1.8-3.3-3.9-3.7V15.8c1.2-.4,2-1.5,2-2.8s-.8-2.4-2-2.8v-5.2c0-.6-.4-1-1-1s-1,.4-1,1v5.2c-1.2.4-2,1.5-2,2.8s.8,2.4,2,2.8v20.3c-2.1.5-3.6,2.3-3.9,3.7-3,1.1-4.6,3.1-3.9,4.1h17.7c.7-1-.9-3-3.9-4.1Z'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        d: 'M38,14H10c-.6,0-1-.4-1-1s.4-1,1-1h28c.6,0,1,.4,1,1s-.4,1-1,1Z'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        id: 'left',
                        d: 'M15.9,27.5h-.7l-4.7-14.7c0-.3-.4-.4-.6-.3-.2,0-.3.3-.3.5l-4.9,14.5h-.5c-.7,1.5,1.9,5,5.9,5s6.6-3.5,5.9-5ZM5.7,27.5l4.3-12.8,4.1,12.8H5.7Z'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        id: 'right',
                        d: 'M43.9,27.5h-.7l-4.7-14.7c0-.3-.4-.4-.6-.3-.2,0-.3.3-.3.5l-4.9,14.5h-.5c-.7,1.5,1.9,5,5.9,5s6.6-3.5,5.9-5ZM33.7,27.5l4.3-12.8,4.2,12.8h-8.5Z'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'GAVEL': {
        element: 'svg',
        attributes: {
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'page',
                        display: 'none'
                    },
                    data: {
                        children: [
                            {
                                element: 'g',
                                attributes: {
                                    id: 'page1',
                                    'data-name': 'page',
                                    display: 'none'
                                },
                                data: {
                                    children: [
                                        {
                                            element: 'path',
                                            attributes: {
                                                d: 'M365.3,91.2c9.9,0,18,8.1,18,18v295c0,9.9-8.1,18-18,18h-218.7c-9.9,0-18-8.1-18-18V109.2c0-9.9,8.1-18,18-18h218.7M365.3,75.2h-218.7c-18.7,0-34,15.3-34,34v295c0,18.7,15.3,34,34,34h218.7c18.7,0,34-15.3,34-34V109.2c0-18.7-15.3-34-34-34h0Z'
                                            },
                                            data: {
                                                children: []
                                            },
                                            meta: {}
                                        }
                                    ]
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    id: 'page2',
                                    'data-name': 'page',
                                    x: '120.3',
                                    y: '83.1',
                                    width: '272',
                                    height: '347.6',
                                    rx: '4',
                                    ry: '4',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'polygon',
                                attributes: {
                                    id: 'corner',
                                    points: '388.2 143.3 331.3 86.4 388.2 86.4 388.2 143.3'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'lines',
                        display: 'none'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '192.4',
                                    y1: '297.8',
                                    x2: '320',
                                    y2: '297.8',
                                    display: 'none',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '192.4',
                                    y1: '345.3',
                                    x2: '279.1',
                                    y2: '345.3',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '192.4',
                                    y1: '155.3',
                                    x2: '320',
                                    y2: '155.3',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '192.4',
                                    y1: '202.8',
                                    x2: '320',
                                    y2: '202.8',
                                    display: 'none',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '192.4',
                                    y1: '250.3',
                                    x2: '320',
                                    y2: '250.3',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'Layer_4'
                    },
                    data: {
                        children: [
                            {
                                element: 'rect',
                                attributes: {
                                    x: '244.9',
                                    y: '179.6',
                                    width: '22.2',
                                    height: '268.4'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    x: '158.7',
                                    y: '103.1',
                                    width: '194.7',
                                    height: '71.1',
                                    rx: '12',
                                    ry: '12'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    x: '154.1',
                                    y: '83.3',
                                    width: '18.7',
                                    height: '110.7',
                                    rx: '6',
                                    ry: '6'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    x: '238.1',
                                    y: '179.6',
                                    width: '35.9',
                                    height: '20.4',
                                    rx: '6',
                                    ry: '6'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    x: '238.1',
                                    y: '433.6',
                                    width: '35.9',
                                    height: '20.4',
                                    rx: '6',
                                    ry: '6'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'GEAR': {
        element: 'svg',
        attributes: {
            id: 'gear',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'path',
                    attributes: {
                        id: 'gear1',
                        'data-name': 'gear',
                        d: 'M289.7,89.2c-9.9-33.6-57.5-33.6-67.4,0l-2.4,8.2c-5.5,18.6-25,29.3-43.6,23.8-2.4-.7-4.7-1.7-6.9-2.9l-7.4-4.1c-30.8-16.8-64.5,16.9-47.7,47.7l4.1,7.5c10.7,19.7.6,44.2-20.9,50.5l-8.2,2.4c-33.6,9.9-33.6,57.5,0,67.4l8.2,2.4c18.6,5.5,29.3,25,23.8,43.6-.7,2.4-1.7,4.7-2.9,6.9l-4.1,7.4c-16.8,30.8,16.9,64.5,47.7,47.7l7.5-4.1c17-9.3,38.4-3,47.7,14,1.2,2.2,2.1,4.5,2.9,6.9l2.4,8.2c9.9,33.6,57.5,33.6,67.4,0l2.4-8.2c5.5-18.6,25-29.3,43.6-23.8,2.4.7,4.7,1.7,6.9,2.9l7.4,4.1c30.8,16.8,64.5-16.9,47.7-47.7l-4.1-7.5c-9.3-17-3-38.4,14-47.7,2.2-1.2,4.5-2.1,6.9-2.9l8.2-2.4c33.6-9.9,33.6-57.5,0-67.4l-8.2-2.4c-18.6-5.5-29.3-25-23.8-43.6.7-2.4,1.7-4.7,2.9-6.9l4.1-7.4c16.8-30.8-16.9-64.5-47.7-47.7l-7.5,4.1c-17,9.3-38.4,3-47.7-14-1.2-2.2-2.1-4.5-2.9-6.9,0,0-2.4-8.2-2.4-8.2ZM256,326.3c-38.8,0-70.3-31.5-70.3-70.3s31.5-70.3,70.3-70.3c38.8,0,70.3,31.5,70.3,70.3,0,38.8-31.5,70.3-70.3,70.3h0Z'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'GITHUB_INVERT': {
        element: 'svg',
        attributes: {
            id: 'user',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'path',
                    attributes: {
                        d: 'M189.3,447.6c12.5,2.3,16.5-5.4,16.5-12v-46.5c-69.4,15.1-83.9-29.5-83.9-29.5-11.4-28.9-27.7-36.5-27.7-36.5-22.7-15.5,1.7-15.2,1.7-15.2,25.1,1.7,38.3,25.7,38.3,25.7,22.3,38.2,58.4,27.1,72.6,20.7,2.2-16.1,8.7-27.1,15.9-33.4-55.4-6.3-113.7-27.8-113.7-123.4s9.8-49.5,25.7-67c-2.6-6.3-11.1-31.7,2.4-66.1,0,0,21-6.7,68.7,25.6,19.9-5.5,41.3-8.3,62.5-8.4,21.2.1,42.6,2.9,62.5,8.4,47.7-32.3,68.6-25.6,68.6-25.6,13.6,34.4,5,59.8,2.5,66.1,16,17.5,25.7,39.8,25.7,67,0,95.9-58.4,117-114,123.2,8.9,7.7,17.1,22.9,17.1,46.2v68.5c0,6.6,4,14.4,16.7,12'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'GITHUB_ROUND': {
        element: 'svg',
        attributes: {
            id: 'user',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'path',
                    attributes: {
                        d: 'M256,68.7c-106,0-192,86-192,192s55,156.8,131.3,182.2c9.6,1.8,12.7-4.2,12.7-9.2v-35.7c-53.4,11.6-64.5-22.7-64.5-22.7-8.7-22.2-21.3-28.1-21.3-28.1-17.4-11.9,1.3-11.7,1.3-11.7,19.3,1.3,29.4,19.8,29.4,19.8,17.1,29.3,44.9,20.9,55.9,16,1.7-12.4,6.7-20.9,12.2-25.7-42.6-4.9-87.5-21.3-87.5-94.9s7.5-38.1,19.8-51.5c-2-4.8-8.6-24.4,1.9-50.8,0,0,16.1-5.2,52.8,19.7,15.3-4.3,31.7-6.4,48-6.5,16.3,0,32.8,2.2,48.1,6.5,36.7-24.8,52.7-19.7,52.7-19.7,10.4,26.4,3.9,46,1.9,50.8,12.3,13.4,19.8,30.6,19.8,51.5,0,73.7-44.9,90-87.7,94.7,6.9,6,13.2,17.6,13.2,35.6v52.7c0,5.1,3.1,11.1,12.8,9.2,76.2-25.4,131.2-97.4,131.2-182.2s-86-192-192-192Z'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'GITLAB': {
        element: 'svg',
        attributes: {
            id: 'user',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'LOGO'
                    },
                    data: {
                        children: [
                            {
                                element: 'path',
                                attributes: {
                                    d: 'M439.2,218l-.5-1.4-51.6-134.6c-1-2.6-2.9-4.9-5.3-6.4-4.9-3.1-11.2-2.7-15.8.8-2.2,1.8-3.8,4.2-4.6,6.9l-34.8,106.6h-141.1l-34.8-106.6c-.8-2.7-2.4-5.2-4.6-7-4.6-3.6-10.9-3.9-15.8-.8-2.4,1.5-4.3,3.8-5.3,6.4l-51.7,134.6-.5,1.4c-15.3,39.9-2.3,85,31.8,110.7h.2c0,.1.5.5.5.5l78.6,58.9,38.9,29.4,23.7,17.9c5.7,4.3,13.6,4.3,19.3,0l23.7-17.9,38.9-29.4,79.1-59.2.2-.2c34-25.7,46.9-70.8,31.7-110.6Z',
                                    fill: '#171321'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'HOME': {
        element: 'svg',
        attributes: {
            id: 'home',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'path',
                    attributes: {
                        id: 'house',
                        d: 'M400,416H112c-8.8,0-16-7.2-16-16v-181.6c0-5.8,3.1-11.1,8.2-13.9l144-105c4.9-2.7,10.8-2.7,15.7,0l144,105c5,2.8,8.2,8.2,8.2,13.9v181.6c0,8.8-7.2,16-16,16Z',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'roof'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '256',
                                    y1: '91.6',
                                    x2: '444.9',
                                    y2: '228.9',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '64',
                                    y1: '229.2',
                                    x2: '256',
                                    y2: '91.6',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'IMAGE': {
        element: 'svg',
        attributes: {
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'page'
                    },
                    data: {
                        children: [
                            {
                                element: 'g',
                                attributes: {
                                    id: 'page1',
                                    'data-name': 'page',
                                    display: 'none'
                                },
                                data: {
                                    children: [
                                        {
                                            element: 'path',
                                            attributes: {
                                                d: 'M365.3,91.2c9.9,0,18,8.1,18,18v295c0,9.9-8.1,18-18,18h-218.7c-9.9,0-18-8.1-18-18V109.2c0-9.9,8.1-18,18-18h218.7M365.3,75.2h-218.7c-18.7,0-34,15.3-34,34v295c0,18.7,15.3,34,34,34h218.7c18.7,0,34-15.3,34-34V109.2c0-18.7-15.3-34-34-34h0Z'
                                            },
                                            data: {
                                                children: []
                                            },
                                            meta: {}
                                        }
                                    ]
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    id: 'page2',
                                    'data-name': 'page',
                                    x: '112',
                                    y: '127.6',
                                    width: '288',
                                    height: '256.4',
                                    rx: '4',
                                    ry: '4',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'lines'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '116.8',
                                    y1: '341.8',
                                    x2: '240.3',
                                    y2: '242.2',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '309.7',
                                    y1: '300',
                                    x2: '240.3',
                                    y2: '242.2',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '309.7',
                                    y1: '300',
                                    x2: '345.2',
                                    y2: '255.8',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '400',
                                    y1: '300',
                                    x2: '345.2',
                                    y2: '255.8',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'circle',
                                attributes: {
                                    cx: '309.7',
                                    cy: '191.9',
                                    r: '25.6',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'LINKEDIN_NOFRAME': {
        element: 'svg',
        attributes: {
            id: 'user',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'path',
                    attributes: {
                        d: 'M448,448h-78.9v-134.4c0-36.8-14-57.4-43.2-57.4s-48.3,21.4-48.3,57.4v134.4h-76v-256h76v34.5s22.9-42.3,77.2-42.3,93.2,33.2,93.2,101.7v162.1ZM110.9,158.5c-25.9,0-46.9-21.2-46.9-47.2s21-47.2,46.9-47.2,46.9,21.2,46.9,47.2-21,47.2-46.9,47.2ZM71.6,448h79.3v-256h-79.3v256Z',
                        'fill-rule': 'evenodd'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'LINKEDIN_SQUARE': {
        element: 'svg',
        attributes: {
            id: 'user',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'path',
                    attributes: {
                        d: 'M106.7,448h298.7c23.6,0,42.7-19.1,42.7-42.7V106.7c0-23.6-19.1-42.7-42.7-42.7H106.7c-23.6,0-42.7,19.1-42.7,42.7v298.7c0,23.6,19.1,42.7,42.7,42.7Z',
                        fill: '#007ebb',
                        'fill-rule': 'evenodd'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        d: 'M394.7,394.7h-57v-97.1c0-26.6-10.1-41.5-31.2-41.5s-34.9,15.5-34.9,41.5v97.1h-54.9v-184.9h54.9v24.9s16.5-30.6,55.7-30.6,67.3,23.9,67.3,73.5v117.1ZM151.2,185.6c-18.7,0-33.9-15.3-33.9-34.1s15.2-34.1,33.9-34.1,33.9,15.3,33.9,34.1-15.1,34.1-33.9,34.1ZM122.8,394.7h57.3v-184.9h-57.3v184.9Z',
                        fill: '#fff',
                        'fill-rule': 'evenodd'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'LINKEDIN': {
        element: 'svg',
        attributes: {
            id: 'user',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'path',
                    attributes: {
                        d: 'M106.7,448h298.7c23.6,0,42.7-19.1,42.7-42.7V106.7c0-23.6-19.1-42.7-42.7-42.7H106.7c-23.6,0-42.7,19.1-42.7,42.7v298.7c0,23.6,19.1,42.7,42.7,42.7Z',
                        fill: '#007ebb',
                        'fill-rule': 'evenodd'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        d: 'M394.7,394.7h-57v-97.1c0-26.6-10.1-41.5-31.2-41.5s-34.9,15.5-34.9,41.5v97.1h-54.9v-184.9h54.9v24.9s16.5-30.6,55.7-30.6,67.3,23.9,67.3,73.5v117.1ZM151.2,185.6c-18.7,0-33.9-15.3-33.9-34.1s15.2-34.1,33.9-34.1,33.9,15.3,33.9,34.1-15.1,34.1-33.9,34.1ZM122.8,394.7h57.3v-184.9h-57.3v184.9Z',
                        fill: '#fff',
                        'fill-rule': 'evenodd'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'LIST': {
        element: 'svg',
        attributes: {
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'dots'
                    },
                    data: {
                        children: [
                            {
                                element: 'circle',
                                attributes: {
                                    cx: '96',
                                    cy: '384',
                                    r: '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'circle',
                                attributes: {
                                    cx: '96',
                                    cy: '256',
                                    r: '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'circle',
                                attributes: {
                                    cx: '96',
                                    cy: '128',
                                    r: '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'lines'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '197.2',
                                    y1: '384',
                                    x2: '416',
                                    y2: '384',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '197.2',
                                    y1: '256',
                                    x2: '416',
                                    y2: '256',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '197.2',
                                    y1: '128',
                                    x2: '416',
                                    y2: '128',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '16'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'LOGO_CLAIMSECURE': {
        element: 'svg',
        attributes: {
            id: 'symbol',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'path',
                    attributes: {
                        d: 'M418.9,163.8c-76.1-91.8-293.2-61.1-293.2,35.5s42.7,69.7,102.5,80.7c80.7,14.8,62.9,76.3,12.2,74.4-98.3-3.7-176.4-62.2-176.4-133.8,0-147.2,274.3-180.5,354.9-56.8h0Z',
                        fill: '#303b69',
                        'fill-rule': 'evenodd'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        d: 'M93.1,345.4c76.1,91.8,293.2,61.1,293.2-35.5s-42.7-69.8-102.5-80.7c-80.7-14.8-62.9-76.3-12.2-74.4,98.3,3.7,176.4,62.2,176.4,133.8,0,147.2-274.3,180.5-354.9,56.8h0Z',
                        'fill-rule': 'evenodd'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'MAGNIFYING_GLASS': {
        element: 'svg',
        attributes: {
            id: 'magnifying-glass',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'line',
                    attributes: {
                        x1: '98.3',
                        y1: '415.6',
                        x2: '224.9',
                        y2: '290.3',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '308',
                        cy: '204',
                        r: '110.9',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'MEGAPHONE': {
        element: 'svg',
        attributes: {
            id: 'Layer_1',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 48 48'
        },
        data: {
            children: [
                {
                    element: 'path',
                    attributes: {
                        d: 'M6,16v16h6l23,10V6l-23,10h-6ZM36,16v16h6v-16h-6Z'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'MEGAPHONE_48PX': {
        element: 'svg',
        attributes: {
            id: 'Icon',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 48 48'
        },
        data: {
            children: [
                {
                    element: 'path',
                    attributes: {
                        d: 'M39.6,40.7l-31.4-10.6c-.8,0-1.4-.6-1.4-1.4v-9.7c0-.8.6-1.4,1.4-1.4l31.4-10.6c.8,0,1.4.6,1.4,1.4v30.8c0,.8-.6,1.4-1.4,1.4Z'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'rect',
                    attributes: {
                        x: '4',
                        y: '17.4',
                        width: '3.3',
                        height: '13.1',
                        rx: '1.2',
                        ry: '1.2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'rect',
                    attributes: {
                        x: '10',
                        y: '32.8',
                        width: '8.6',
                        height: '3.6',
                        rx: '1.4',
                        ry: '1.4',
                        transform: 'translate(51.8 33.8) rotate(111.1)'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'rect',
                    attributes: {
                        x: '40.7',
                        y: '6',
                        width: '3.3',
                        height: '35.8',
                        rx: '1.2',
                        ry: '1.2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'MINUS': {
        element: 'svg',
        attributes: {
            id: 'minus',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'line',
                    attributes: {
                        id: 'minus1',
                        'data-name': 'minus',
                        x1: '96',
                        y1: '256',
                        x2: '416',
                        y2: '256',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'MINUS_48PX': {
        element: 'svg',
        attributes: {
            id: 'Icon',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 48 48'
        },
        data: {
            children: [
                {
                    element: 'line',
                    attributes: {
                        id: 'line-1',
                        x1: '43',
                        y1: '24',
                        x2: '5',
                        y2: '24',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'MULTIPLY': {
        element: 'svg',
        attributes: {
            id: 'symbol',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'line',
                    attributes: {
                        id: 'line-2',
                        x1: '142.9',
                        y1: '369.1',
                        x2: '369.1',
                        y2: '142.9',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '64'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        id: 'line-1',
                        x1: '369.1',
                        y1: '369.1',
                        x2: '142.9',
                        y2: '142.9',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '64'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'NAV_LEFT_FILL': {
        element: 'svg',
        attributes: {
            id: 'nav-left',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'window'
                    },
                    data: {
                        children: [
                            {
                                element: 'rect',
                                attributes: {
                                    id: 'panel',
                                    x: '81.3',
                                    y: '82',
                                    width: '349.8',
                                    height: '349.4',
                                    rx: '26.9',
                                    ry: '26.9',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-linejoin': 'round',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    id: 'sidebar',
                                    x: '81.3',
                                    y: '82',
                                    width: '137.5',
                                    height: '349.4',
                                    transform: 'translate(300.1 513.4) rotate(180)'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'arrow'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '360',
                                    y1: '184.8',
                                    x2: '271.3',
                                    y2: '255.7',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '360',
                                    y1: '326.6',
                                    x2: '271.3',
                                    y2: '255.7',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'NAV_LEFT_STROKE': {
        element: 'svg',
        attributes: {
            id: 'nav-left',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'window'
                    },
                    data: {
                        children: [
                            {
                                element: 'rect',
                                attributes: {
                                    id: 'panel',
                                    x: '81.3',
                                    y: '82',
                                    width: '349.8',
                                    height: '349.4',
                                    rx: '26.9',
                                    ry: '26.9',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-linejoin': 'round',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    id: 'sidebar',
                                    x1: '218.8',
                                    y1: '82',
                                    x2: '218.8',
                                    y2: '431.4',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'arrow'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '360',
                                    y1: '184.8',
                                    x2: '271.3',
                                    y2: '255.7',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '360',
                                    y1: '326.6',
                                    x2: '271.3',
                                    y2: '255.7',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'NAV_LEFT': {
        element: 'svg',
        attributes: {
            id: 'nav-left',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'window'
                    },
                    data: {
                        children: [
                            {
                                element: 'rect',
                                attributes: {
                                    id: 'panel',
                                    x: '81.3',
                                    y: '82',
                                    width: '349.8',
                                    height: '349.4',
                                    rx: '26.9',
                                    ry: '26.9',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-linejoin': 'round',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    id: 'sidebar',
                                    x: '81.3',
                                    y: '82',
                                    width: '137.5',
                                    height: '349.4',
                                    transform: 'translate(300.1 513.4) rotate(180)'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'arrow'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '360',
                                    y1: '184.8',
                                    x2: '271.3',
                                    y2: '255.7',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '360',
                                    y1: '326.6',
                                    x2: '271.3',
                                    y2: '255.7',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'NAV_RIGHT_FILL': {
        element: 'svg',
        attributes: {
            id: 'nav-right',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'window'
                    },
                    data: {
                        children: [
                            {
                                element: 'rect',
                                attributes: {
                                    id: 'panel',
                                    x: '81.3',
                                    y: '82',
                                    width: '349.8',
                                    height: '349.4',
                                    rx: '26.9',
                                    ry: '26.9',
                                    transform: 'translate(512.4 513.4) rotate(180)',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-linejoin': 'round',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    id: 'sidebar',
                                    x: '293.7',
                                    y: '82',
                                    width: '137.5',
                                    height: '349.4'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'arrow'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '152.4',
                                    y1: '328.7',
                                    x2: '241.1',
                                    y2: '257.8',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '152.4',
                                    y1: '186.9',
                                    x2: '241.1',
                                    y2: '257.8',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'NAV_RIGHT_STROKE': {
        element: 'svg',
        attributes: {
            id: 'nav-right',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'window'
                    },
                    data: {
                        children: [
                            {
                                element: 'rect',
                                attributes: {
                                    id: 'panel',
                                    x: '81.3',
                                    y: '82',
                                    width: '349.8',
                                    height: '349.4',
                                    rx: '26.9',
                                    ry: '26.9',
                                    transform: 'translate(512.4 513.4) rotate(180)',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-linejoin': 'round',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    id: 'sidebar',
                                    x1: '293.7',
                                    y1: '431.4',
                                    x2: '293.7',
                                    y2: '82',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'arrow'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '152.4',
                                    y1: '328.7',
                                    x2: '241.1',
                                    y2: '257.8',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '152.4',
                                    y1: '186.9',
                                    x2: '241.1',
                                    y2: '257.8',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'NAV_RIGHT': {
        element: 'svg',
        attributes: {
            id: 'nav-right',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'window'
                    },
                    data: {
                        children: [
                            {
                                element: 'rect',
                                attributes: {
                                    id: 'panel',
                                    x: '81.3',
                                    y: '82',
                                    width: '349.8',
                                    height: '349.4',
                                    rx: '26.9',
                                    ry: '26.9',
                                    transform: 'translate(512.4 513.4) rotate(180)',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-linejoin': 'round',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'rect',
                                attributes: {
                                    id: 'sidebar',
                                    x: '293.7',
                                    y: '82',
                                    width: '137.5',
                                    height: '349.4'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'arrow'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '152.4',
                                    y1: '328.7',
                                    x2: '241.1',
                                    y2: '257.8',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '152.4',
                                    y1: '186.9',
                                    x2: '241.1',
                                    y2: '257.8',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'NINE_DOTS': {
        element: 'svg',
        attributes: {
            id: 'dots',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'circle',
                    attributes: {
                        cx: '384',
                        cy: '384',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '384',
                        cy: '256',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '384',
                        cy: '128',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '256',
                        cy: '384',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '256',
                        cy: '256',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '256',
                        cy: '128',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '129',
                        cy: '384',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '129',
                        cy: '256',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '129',
                        cy: '128',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'PANELS_FILL': {
        element: 'svg',
        attributes: {
            id: 'panels',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'rect',
                    attributes: {
                        id: 'panel',
                        x: '65.4',
                        y: '160',
                        width: '381.1',
                        height: '288',
                        rx: '32',
                        ry: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        id: 'line-1',
                        x1: '128',
                        y1: '131',
                        x2: '384',
                        y2: '131',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '35'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        id: 'line-2',
                        x1: '358',
                        y1: '83',
                        x2: '154',
                        y2: '83',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '35'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'PANELS_STROKE': {
        element: 'svg',
        attributes: {
            id: 'panels',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'rect',
                    attributes: {
                        id: 'panel',
                        x: '75',
                        y: '167.2',
                        width: '362',
                        height: '273.6',
                        rx: '32',
                        ry: '32',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        id: 'line-1',
                        x1: '128',
                        y1: '131',
                        x2: '384',
                        y2: '131',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        id: 'line-2',
                        x1: '358',
                        y1: '83',
                        x2: '154',
                        y2: '83',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'PANELS': {
        element: 'svg',
        attributes: {
            id: 'panels',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'rect',
                    attributes: {
                        id: 'panel',
                        x: '65.4',
                        y: '160',
                        width: '381.1',
                        height: '288',
                        rx: '32',
                        ry: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        id: 'line-1',
                        x1: '128',
                        y1: '131',
                        x2: '384',
                        y2: '131',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '35'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        id: 'line-2',
                        x1: '358',
                        y1: '83',
                        x2: '154',
                        y2: '83',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '35'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'PLUS': {
        element: 'svg',
        attributes: {
            id: 'symbol',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'line',
                    attributes: {
                        x1: '96',
                        y1: '256',
                        x2: '416',
                        y2: '256',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        x1: '256',
                        y1: '416',
                        x2: '256',
                        y2: '96',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'PLUS_48PX': {
        element: 'svg',
        attributes: {
            id: 'Icon',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 48 48'
        },
        data: {
            children: [
                {
                    element: 'line',
                    attributes: {
                        id: 'line-2',
                        x1: '24',
                        y1: '43',
                        x2: '24',
                        y2: '5',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        id: 'line-1',
                        x1: '43',
                        y1: '24',
                        x2: '5',
                        y2: '24',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'PROMPT': {
        element: 'svg',
        attributes: {
            id: 'prompt',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'line',
                    attributes: {
                        id: 'underscore',
                        x1: '256',
                        y1: '384',
                        x2: '416',
                        y2: '384',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'gt'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    id: 'bottom',
                                    x1: '96',
                                    y1: '384',
                                    x2: '256.1',
                                    y2: '256',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    id: 'top',
                                    x1: '96',
                                    y1: '128',
                                    x2: '256.1',
                                    y2: '256',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'RANDOM': {
        element: 'svg',
        attributes: {
            id: 'Layer_5',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'path',
                    attributes: {
                        d: 'M329.9,148.7c0,46.7-33.3,84.5-74.4,84.5s-74.4-37.8-74.4-84.5,33.3-84.5,74.4-84.5,74.4,37.8,74.4,84.5Z'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        d: 'M255.5,395.6c-76.5,0-116.6-45-116.6-100.5s3.1-66.2,41-84.2c17.1,23.2,44.6,38.3,75.7,38.3s58.6-15.1,75.7-38.3c37.8,17.9,41,48.9,41,84.2,0,55.5-40.2,100.5-116.6,100.5Z'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'ellipse',
                    attributes: {
                        cx: '129.1',
                        cy: '121.7',
                        rx: '45.3',
                        ry: '52.4',
                        fill: '#2427ff'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'polygon',
                    attributes: {
                        points: '162.2 359.5 234.1 287.9 188.3 197.3 278.6 243.6 350.6 172 334.4 272.2 424.7 318.6 324.4 334.2 308.3 434.4 262.5 343.8 162.2 359.5',
                        fill: '#60ff44'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        d: 'M312.7,92.1c-22.7-3.9-44.6,4.2-62.5,17.9-8.5,6.5-16.7,13.8-23.7,21.9s-9,17.9-2.8,27c12.9,19,37.9,13.7,56.4,21.7,7.6,3.3,17.1,10.8,15.2,20.3-2.2,10.5-14.8,13.9-23.9,14.6-24.6,1.9-49.6-2.4-74-5.2-22.6-2.6-47.2-5.9-69.7-1.1-9.6,2-18.6,6.7-24.3,14.9s-7.6,18.8-8.9,28.6-.8,21.3,4.8,30.5c4.4,7.3,11.1,12.8,17.5,18.3,6.8,5.8,14.6,12.2,16.3,21.5s-4.8,22.4-13.1,29.5-20.3,11.2-30.6,16.8-16.6,12.6-14.6,23.6,13,4.4,11.6-3.2,13.6-12.2,18.5-14.4c9.1-4.1,18-9,25.4-15.9,13.7-12.9,20.5-34.1,9.7-50.9-8.6-13.4-26.6-20.3-32.4-35.4s-1.5-20.6.8-30,7.3-17.6,17.4-20.9,19.8-3,29.7-2.9,24.2,1.2,36.3,2.5c23.5,2.6,47,6.2,70.6,6.2s21.7-.7,30.9-6.3,13.7-12.6,14.3-21.8c1.1-19.9-20-30.8-36.6-34s-24.8-2.2-33.7-9.7-6.8-7.7-4.3-12.6,7.7-9,11.6-12.7c17.2-16.6,40.1-31.5,65.1-27.1,7.6,1.3,10.8-10.3,3.2-11.6h0Z',
                        fill: '#ff1c46'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'SIX_DOTS_HORIZONTAL': {
        element: 'svg',
        attributes: {
            id: 'dots',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'circle',
                    attributes: {
                        cx: '128',
                        cy: '319.5',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '256',
                        cy: '319.5',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '384',
                        cy: '319.5',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '128',
                        cy: '192.5',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '256',
                        cy: '192.5',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '384',
                        cy: '192.5',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'SIX_DOTS_VERTICAL': {
        element: 'svg',
        attributes: {
            id: 'dots',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'circle',
                    attributes: {
                        cx: '319.5',
                        cy: '384',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '319.5',
                        cy: '256',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '319.5',
                        cy: '128',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '192.5',
                        cy: '384',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '192.5',
                        cy: '256',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '192.5',
                        cy: '128',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'SLASH': {
        element: 'svg',
        attributes: {
            id: 'symbol',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'line',
                    attributes: {
                        x1: '369.1',
                        y1: '369.1',
                        x2: '142.9',
                        y2: '142.9',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '64'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'SPEAKUP_48PX': {
        element: 'svg',
        attributes: {
            id: 'Icon',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 48 48'
        },
        data: {
            children: [
                {
                    element: 'path',
                    attributes: {
                        id: 'Bubble',
                        d: 'M9.7,43.5c-.1,0-.2,0-.3-.1-.1-.1-.2-.4-.1-.5,0,0,.7-2,3-9.9-5.1-2.8-8.2-7.1-8.2-11.8,0-8.1,9-14.6,20-14.6s20,6.6,20,14.6-8.9,14.6-19.9,14.6c-9.8,5.6-14.2,7.6-14.2,7.7,0,0-.1,0-.2,0ZM24,7.5c-10.5,0-19,6.1-19,13.6s3,8.6,8,11.1c.2.1.3.4.3.6-1.4,5.1-2.3,7.8-2.7,9.2,1.8-.9,6.1-3.1,13.2-7.2,0,0,.2,0,.2,0,10.5,0,19-6.1,19-13.6s-8.5-13.6-19-13.6Z'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '24',
                        cy: '29.5',
                        r: '2.5'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        id: 'Rectangle',
                        d: 'M25,26h-2c-.6,0-1-.4-1-1l-1-20c0-.6.4-1,1-1h4c.6,0,1,.4,1,1l-1,20c0,.6-.4,1-1,1Z'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'SPOONMEDIA_FILL': {
        element: 'svg',
        attributes: {
            id: 'spoonmedia',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'path',
                    attributes: {
                        id: 'spoon',
                        d: 'M442,256.1c0-102.8-83.3-186.1-186-186.1s-186,83.3-186,186.1,77.9,180.6,175.9,185.9l3-92.1c2.7-21.8-55.4-23.7-55.4-87.9s29.9-113.5,60.6-114.1c31.7-.6,64.5,51.2,64.5,116s-50.5,57.9-54.5,86.7l2,91.6c98.1-5.2,176-86.4,176-185.9h0Z',
                        'fill-rule': 'evenodd'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'SPOONMEDIA_STROKE': {
        element: 'svg',
        attributes: {
            id: 'spoonmedia',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'g',
                    attributes: {
                        id: 'spoon'
                    },
                    data: {
                        children: [
                            {
                                element: 'path',
                                attributes: {
                                    d: 'M256,86c45.4,0,88.1,17.7,120.2,49.8,31.7,31.8,49.4,73.8,49.8,118.7v1.6c0,84.9-62.2,155.8-144.4,168.2l-1.6-72.6c1.2-4.3,6.1-8.3,14.4-14.5,16-12,40.1-30.2,40.1-73.5s-7.9-65.1-22.2-90.1c-15.3-26.6-36.3-41.9-57.6-41.9s-.6,0-.9,0c-20.9.4-41.2,15.5-55.5,41.5-13.4,24.2-20.8,55.7-20.8,88.7,0,48.2,28.5,68.3,45.6,80.3,3.2,2.3,7.9,5.6,9.8,7.5l-2.4,74.6c-37.5-5.5-71.8-22.9-97.7-49.8-30.1-31.3-46.7-73.4-46.7-118.4s17.7-88.2,49.8-120.3c32.1-32.1,74.8-49.8,120.2-49.8M256,70c-102.7,0-186,83.3-186,186.1s77.9,180.6,175.9,185.9l3-92.1c2.7-21.8-55.4-23.7-55.4-87.9s29.8-113.5,60.6-114.1c.2,0,.4,0,.6,0,31.6,0,63.9,51.6,63.9,116s-50.5,57.9-54.5,86.7l2,91.6c98.1-5.2,176-86.4,176-185.9h0c0-102.8-83.3-186.1-186-186.1h0Z'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'SPOONMEDIA_WIDE': {
        element: 'svg',
        attributes: {
            id: 'spoonmedia',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 1679.2 512'
        },
        data: {
            children: [
                {
                    element: 'rect',
                    attributes: {
                        x: '32.8',
                        y: '7.1',
                        width: '1602.1',
                        height: '497.8',
                        rx: '248.9',
                        ry: '248.9'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        id: 'circle',
                        cx: '283.5',
                        cy: '256',
                        r: '242',
                        fill: '#fff'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        id: 'spoon',
                        d: 'M517.9,256.2c0-129.6-105-234.6-234.4-234.6S49.1,126.6,49.1,256.2s98.1,227.6,221.7,234.3l3.7-116.1c3.4-27.5-69.8-29.9-69.8-110.8s37.6-143.1,76.4-143.9c40-.8,81.2,64.6,81.2,146.1s-63.7,72.9-68.8,109.3l2.6,115.4c123.6-6.6,221.8-108.9,221.8-234.3h0Z',
                        'fill-rule': 'evenodd'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'text',
                    attributes: {
                        transform: 'translate(576 290.1)',
                        fill: '#fff',
                        'font-family': 'NimbusSan-Bol, \'Nimbus Sans\'',
                        'font-size': '140.8'
                    },
                    data: {
                        children: [
                            {
                                element: 'tspan',
                                attributes: {
                                    x: '0',
                                    y: '0'
                                },
                                data: {
                                    children: [],
                                    text: 'spoonmedia'
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'SPOONMEDIA': {
        element: 'svg',
        attributes: {
            id: 'spoonmedia',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'circle',
                    attributes: {
                        id: 'circle',
                        cx: '256',
                        cy: '256',
                        r: '192',
                        fill: '#fff'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        id: 'spoon',
                        d: 'M442,256.1c0-102.8-83.3-186.1-186-186.1s-186,83.3-186,186.1,77.9,180.6,175.9,185.9l3-92.1c2.7-21.8-55.4-23.7-55.4-87.9s29.9-113.5,60.6-114.1c31.7-.6,64.5,51.2,64.5,116s-50.5,57.9-54.5,86.7l2,91.6c98.1-5.2,176-86.4,176-185.9h0Z',
                        'fill-rule': 'evenodd'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'STACK': {
        element: 'svg',
        attributes: {
            id: 'stack',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'path',
                    attributes: {
                        id: 'stack1',
                        'data-name': 'stack',
                        d: 'M261.6,103.1c-3.5-1.9-7.7-1.9-11.1,0l-177.8,94.8c-5.8,3.1-8,10.3-4.9,16,1.1,2.1,2.8,3.8,4.9,4.9l69.3,37-69.3,37c-5.8,3.1-8,10.3-4.9,16,1.1,2.1,2.8,3.8,4.9,4.9l177.8,94.8c3.5,1.9,7.7,1.9,11.1,0l177.8-94.8c5.8-3.1,8-10.3,4.9-16-1.1-2.1-2.8-3.8-4.9-4.9l-69.2-37,69.3-37c5.8-3.1,8-10.3,4.9-16-1.1-2.1-2.8-3.8-4.9-4.9l-177.8-94.8ZM256,289.8l-152.6-81.4,152.6-81.4,152.6,81.4-152.6,81.4Z'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'STACKOVERFLOW': {
        element: 'svg',
        attributes: {
            id: 'user',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'path',
                    attributes: {
                        d: 'M376.1,413.9v-102.9h34.1v137H102.1v-137h34.1v102.9h239.9Z',
                        fill: '#bcbbbb'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        d: 'M173.9,301.2l167.6,35,7.1-33.7-167.6-35-7.1,33.7ZM196.1,221.4l155.2,72.3,14.2-31-155.2-72.7s-14.2,31.5-14.2,31.5ZM239.1,145.1l131.7,109.5,21.7-26.2-131.7-109.5s-21.7,26.2-21.7,26.2ZM324.2,64l-27.5,20.4,102,137.5,27.5-20.4-102-137.5ZM170.4,379.3h171.2v-34.1h-171.2v34.1Z',
                        fill: '#f48023'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'TAB': {
        element: 'svg',
        attributes: {
            id: 'tab',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'rect',
                    attributes: {
                        id: 'square',
                        x: '81.3',
                        y: '142.3',
                        width: '288.8',
                        height: '288.8',
                        rx: '26.9',
                        ry: '26.9',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-linejoin': 'round',
                        'stroke-width': '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        id: 'outer',
                        d: 'M149.1,81.7c163-1,221-1,221-1,41.8,0,61.9,20.3,61.9,62.9v220.5',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-linejoin': 'round',
                        'stroke-width': '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'plus'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    id: 'line-2',
                                    x1: '160',
                                    y1: '286.7',
                                    x2: '288',
                                    y2: '286.7',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-linejoin': 'round',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    id: 'line-1',
                                    x1: '224',
                                    y1: '350.7',
                                    x2: '224',
                                    y2: '222.7',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-linecap': 'round',
                                    'stroke-linejoin': 'round',
                                    'stroke-width': '32'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'TABLE': {
        element: 'svg',
        attributes: {
            id: 'tab',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'rect',
                    attributes: {
                        id: 'panel',
                        x: '81.3',
                        y: '112.3',
                        width: '349.8',
                        height: '288.8',
                        rx: '26.9',
                        ry: '26.9',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-linejoin': 'round',
                        'stroke-width': '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'g',
                    attributes: {
                        id: 'grid'
                    },
                    data: {
                        children: [
                            {
                                element: 'line',
                                attributes: {
                                    x1: '81.3',
                                    y1: '241.3',
                                    x2: '431.1',
                                    y2: '241.3',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '12'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '81.3',
                                    y1: '291.3',
                                    x2: '431.1',
                                    y2: '291.3',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '12'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '81.3',
                                    y1: '341.3',
                                    x2: '431.1',
                                    y2: '341.3',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '12'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '151',
                                    y1: '401.1',
                                    x2: '151',
                                    y2: '191.4',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '12'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '256',
                                    y1: '401.1',
                                    x2: '256',
                                    y2: '191.4',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '12'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            },
                            {
                                element: 'line',
                                attributes: {
                                    x1: '361',
                                    y1: '401.1',
                                    x2: '361',
                                    y2: '191.4',
                                    fill: 'none',
                                    stroke: '#000',
                                    'stroke-miterlimit': '10',
                                    'stroke-width': '12'
                                },
                                data: {
                                    children: []
                                },
                                meta: {}
                            }
                        ]
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        id: 'nav',
                        d: 'M81.3,122.3v71h349.8v-71H81.3ZM111.6,180.3c-7.2,0-13-5.8-13-13s5.8-13,13-13,13,5.8,13,13-5.8,13-13,13ZM143.3,180.3c-7.2,0-13-5.8-13-13s5.8-13,13-13,13,5.8,13,13c0,7.2-5.8,13-13,13ZM175,180.3c-7.2,0-13-5.8-13-13s5.8-13,13-13,13,5.8,13,13-5.8,13-13,13Z'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'THREE_DOTS_HORIZONTAL': {
        element: 'svg',
        attributes: {
            id: 'dots',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'circle',
                    attributes: {
                        cx: '384',
                        cy: '256',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '256',
                        cy: '256',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '128',
                        cy: '256',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'THREE_DOTS_VERTICAL': {
        element: 'svg',
        attributes: {
            id: 'dots',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'circle',
                    attributes: {
                        cx: '256',
                        cy: '384',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '256',
                        cy: '256',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '256',
                        cy: '128',
                        r: '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'THREE_LINES_HORIZONTAL': {
        element: 'svg',
        attributes: {
            id: 'lines',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'line',
                    attributes: {
                        x1: '96',
                        y1: '384',
                        x2: '416',
                        y2: '384',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        x1: '96',
                        y1: '256',
                        x2: '416',
                        y2: '256',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        x1: '96',
                        y1: '128',
                        x2: '416',
                        y2: '128',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'THREE_LINES_HORIZONTAL_48PX': {
        element: 'svg',
        attributes: {
            id: 'Icon',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 48 48'
        },
        data: {
            children: [
                {
                    element: 'line',
                    attributes: {
                        id: 'line-1',
                        x1: '43',
                        y1: '24',
                        x2: '5',
                        y2: '24',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        id: 'line-11',
                        'data-name': 'line-1',
                        x1: '43',
                        y1: '38',
                        x2: '5',
                        y2: '38',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        id: 'line-12',
                        'data-name': 'line-1',
                        x1: '43',
                        y1: '10',
                        x2: '5',
                        y2: '10',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '2'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'THREE_LINES_VERTICAL': {
        element: 'svg',
        attributes: {
            id: 'lines',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'line',
                    attributes: {
                        x1: '384',
                        y1: '416',
                        x2: '384',
                        y2: '96',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '64'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        x1: '256',
                        y1: '416',
                        x2: '256',
                        y2: '96',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '64'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'line',
                    attributes: {
                        x1: '128',
                        y1: '416',
                        x2: '128',
                        y2: '96',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '64'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'UNDERSCORE': {
        element: 'svg',
        attributes: {
            id: 'symbol',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'line',
                    attributes: {
                        x1: '96',
                        y1: '384',
                        x2: '416',
                        y2: '384',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '64'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'USER': {
        element: 'svg',
        attributes: {
            id: 'user',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'path',
                    attributes: {
                        id: 'body',
                        d: 'M99,422.7c0-86.7,70.3-148.7,157-148.7s157,62,157,148.7',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        id: 'head',
                        cx: '256',
                        cy: '181.8',
                        r: '92',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-miterlimit': '10',
                        'stroke-width': '16'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'WHISTLE_48PX': {
        element: 'svg',
        attributes: {
            id: 'Icon',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 48 48'
        },
        data: {
            children: [
                {
                    element: 'circle',
                    attributes: {
                        cx: '15',
                        cy: '28',
                        r: '11'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'polygon',
                    attributes: {
                        points: '44 24 15 29 15 17 44 17 44 24'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '11',
                        cy: '18',
                        r: '4'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '15',
                        cy: '27.8',
                        r: '6.2',
                        fill: '#fff'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'circle',
                    attributes: {
                        cx: '14.8',
                        cy: '28',
                        r: '3.8'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'rect',
                    attributes: {
                        x: '25',
                        y: '5',
                        width: '2',
                        height: '8'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'rect',
                    attributes: {
                        x: '20.9',
                        y: '5.9',
                        width: '2',
                        height: '8',
                        transform: 'translate(-1.9 6.9) rotate(-17.3)'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'rect',
                    attributes: {
                        x: '29.3',
                        y: '5.9',
                        width: '2',
                        height: '8',
                        transform: 'translate(5.2 -9.7) rotate(19.9)'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'rect',
                    attributes: {
                        x: '24',
                        y: '16',
                        width: '4',
                        height: '2',
                        fill: '#fff'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'WINDOW': {
        element: 'svg',
        attributes: {
            id: 'tab',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'rect',
                    attributes: {
                        id: 'panel',
                        x: '81.3',
                        y: '112.3',
                        width: '349.8',
                        height: '288.8',
                        rx: '26.9',
                        ry: '26.9',
                        fill: 'none',
                        stroke: '#000',
                        'stroke-linecap': 'round',
                        'stroke-linejoin': 'round',
                        'stroke-width': '32'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        id: 'nav',
                        d: 'M81.3,122.3v71h349.8v-71H81.3ZM111.6,180.3c-7.2,0-13-5.8-13-13s5.8-13,13-13,13,5.8,13,13-5.8,13-13,13ZM143.3,180.3c-7.2,0-13-5.8-13-13s5.8-13,13-13,13,5.8,13,13c0,7.2-5.8,13-13,13ZM175,180.3c-7.2,0-13-5.8-13-13s5.8-13,13-13,13,5.8,13,13-5.8,13-13,13Z'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    },
    'WORDPRESS': {
        element: 'svg',
        attributes: {
            id: 'user',
            xmlns: 'http://www.w3.org/2000/svg',
            version: '1.1',
            viewBox: '0 0 512 512'
        },
        data: {
            children: [
                {
                    element: 'path',
                    attributes: {
                        d: 'M91.3,256c0,65.2,37.9,121.5,92.8,148.2l-78.6-215.3c-9.1,20.5-14.3,43.2-14.3,67Z',
                        fill: '#464342'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        d: 'M367.2,247.7c0-20.4-7.3-34.5-13.6-45.4-8.3-13.6-16.2-25.1-16.2-38.6s11.5-29.2,27.7-29.2,1.4,0,2.1.1c-29.3-26.8-68.3-43.2-111.2-43.2s-108.2,29.5-137.6,74.2c3.9.1,7.5.2,10.6.2,17.2,0,43.9-2.1,43.9-2.1,8.9-.5,9.9,12.5,1.1,13.6,0,0-8.9,1-18.9,1.6l60,178.4,36-108.1-25.7-70.3c-8.9-.5-17.3-1.6-17.3-1.6-8.9-.5-7.8-14.1,1-13.6,0,0,27.2,2.1,43.4,2.1s43.9-2.1,43.9-2.1c8.9-.5,9.9,12.5,1.1,13.6,0,0-8.9,1-18.9,1.6l59.5,177.1,16.4-54.9c7.1-22.8,12.5-39.1,12.5-53.2Z',
                        fill: '#464342'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        d: 'M258.9,270.4l-49.4,143.6c14.8,4.3,30.4,6.7,46.5,6.7s37.6-3.3,54.7-9.3c-.4-.7-.8-1.5-1.2-2.3l-50.6-138.7Z',
                        fill: '#464342'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        d: 'M400.5,177c.7,5.2,1.1,10.9,1.1,16.9,0,16.7-3.1,35.5-12.5,59l-50.3,145.5c49-28.6,81.9-81.6,81.9-142.4,0-28.6-7.3-55.6-20.2-79Z',
                        fill: '#464342'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                },
                {
                    element: 'path',
                    attributes: {
                        d: 'M256,64c-105.9,0-192,86.1-192,192s86.1,192,192,192,192-86.1,192-192c0-105.9-86.1-192-192-192ZM256,439.2c-101,0-183.2-82.2-183.2-183.2S155,72.8,256,72.8s183.2,82.2,183.2,183.2-82.2,183.2-183.2,183.2Z',
                        fill: '#464342'
                    },
                    data: {
                        children: []
                    },
                    meta: {}
                }
            ]
        },
        meta: {}
    }
};
